import type { ReactNode } from 'react'
import WindowContainer from '../layout/WindowContainer'
import Header from '../layout/Header'
import Footer from '../layout/Footer'

/** Page chrome shared by all blog/tool pages (reuses the landing-page layout). */
export default function ContentShell({ children }: { children: ReactNode }) {
  return (
    <WindowContainer>
      <Header />
      <main>{children}</main>
      <Footer />
    </WindowContainer>
  )
}
